import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AddSonValuesType } from "src/core/types/add-son-form-type";
import AddSonFormComponent from "./add-son-form-component";

function SonsListComponent() {
  const { t, i18n } = useTranslation();
  const [showAddSonForm, setShowAddSonForm] = useState<boolean>(false);
  const [sonsList, setSonsList] = useState<AddSonValuesType[]>([]);
  const addSonFormRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutSideForm = ({ target }: MouseEvent) => {
      if (!addSonFormRef?.current?.contains(target as Node)) {
        setShowAddSonForm(false);
      }
    };
    document.body.addEventListener("click", handleClickOutSideForm, true);

    return () => {
      document.body.removeEventListener("click", handleClickOutSideForm);
    };
  }, []);
  const addSonToList = (sonData: AddSonValuesType) => {
    setSonsList([...sonsList, sonData]);
  };
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className={`flex flex-col ${
        sonsList.length === 0 ? "items-center" : "items-start"
      } mt-16`}
    >
      {sonsList.length === 0 ? (
        <div className="w-[409px] h-[264px] flex flex-col justify-start items-center gap-5">
          <img alt="sorry" src="/assets/images/sorry.png" />
          <div className="flex-col justify-start items-center gap-3 flex">
            <div className="text-center text-zinc900 text-2xl font-arMedium">
              {t("sons.component.noChildrenAdded")}
            </div>
            <div className="w-[409px] text-center text-zinc500 text-lg font-arMedium">
              {t("sons.component.addChildrenToSubmit")}
            </div>
            <button
              onClick={() => setShowAddSonForm(true)}
              className="w-[122px] h-11 p-2 bg-mint-500 rounded-xl text-white text-lg font-arMedium"
            >
              {t("sons.component.addSon")}
            </button>
          </div>
        </div>
      ) : (
        <>
          {sonsList.map((son, index) => {
            return (
              <div
                key={index}
                className="flex flex-col gap-3"
              >
                <div className="w-[447px] h-[212px] mobile:w-[327px] mobile:h-auto p-6 bg-white rounded-2xl shadow border border-neutral-50 flex-col justify-start items-start gap-4 flex">
                  <div className="self-stretch text-zinc-700 text-xl font-bold font-['Tajawal'] leading-[30px]">
                    {son.nameOfSon}
                  </div>
                  <div className="justify-center items-center gap-[13px] inline-flex">
                    <div className="w-[303px] flex-col justify-start items-start gap-4 inline-flex">
                      <div className="h-[118px] flex-col justify-start items-start gap-3 flex">
                        <div className="self-stretch h-[53px] flex-col justify-start items-start gap-2 flex">
                          <div className="self-stretch text-zinc-400 text-xs font-arRegular">
                            {t("app.shared.birthday")}
                          </div>
                          <div className="self-stretch text-zinc-400 text-lg font-arRegular">
                            {son.birthDate.replaceAll("-", "/")}
                          </div>
                        </div>
                        <div className="self-stretch h-[53px] flex-col justify-start items-start gap-2 flex">
                          <div className="self-stretch text-zinc-400 text-xs font-arRegular">
                            {t("forms.component.educationevel")}
                          </div>
                          <div className="self-stretch text-zinc-400 text-lg font-arRegular">
                            {son.eduLevel}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}

      {showAddSonForm && (
        <AddSonFormComponent
          addSonFormRef={addSonFormRef}
          addSonToList={addSonToList}
          setShowAddSonForm={setShowAddSonForm}
        />
      )}
    </div>
  );
}

export default SonsListComponent;
